import moment from 'moment';

export const renderDate = (date) => moment(date).format('MMMM D, YYYY');
